import $http from '../assets/js/http'

const MODULE = {
  id: 1700,
  power: 1,
  list: {
    id: 1701,
    power: 2,
    path: '/sysConfig/query/all'
  },
  info: {
    id: 1701,
    power: 2,
    path: '/sysConfig/query/info'
  },
  update: {
    id: 1702,
    power: 4,
    path: '/sysConfig/update/info'
  }
}

export function getList (params, enableLoading = true) {
  params = $http.custom(params, {moduleId: MODULE.list.id, enableLoading: enableLoading})
  return $http.post(MODULE.list.path, params)
}

export function getInfo (params) {
  params = $http.custom(params, {moduleId: MODULE.info.id})
  return $http.post(MODULE.info.path, params)
}

export function update (params) {
  params = $http.custom(params, {moduleId: MODULE.update.id})
  return $http.post(MODULE.update.path, params)
}

export default {
  MODULE,
  getList,
  getInfo,
  update
}



// WEBPACK FOOTER //
// ./src/api/sysConfig.js